import React from "react";
import "./iframeImg.scss";
import trueIcon from "../../../images/frames/green-check-icon.svg";
import falseIcon from "../../../images/frames/red-check-icon.svg";

const IframeImg = ({ imgSrc, isTrue, classNameParam }) => {
    return (
        <div className={`iFrameImg ${classNameParam}`}>
            <img src={imgSrc} alt="photo" className="iFrameImg__img" />
            <div className="iFrameImg__selectIcon">
                <img src={isTrue ? trueIcon : falseIcon} alt="true" className="iFrameImg__img__selectIcon-img" />
            </div>
        </div>
    );
};

export default IframeImg;
